module.exports = __webpack_public_path__ + "img/banner.07419d65.jpg";